const frontEnd = {
  profile: "/profile",

  bulkUpload: "/bulk-upload",
  reviewReports: "/review-reports",
  singleUpload: "/single-upload",
  results: "/results",
  review: "/review",
  test: "/test",
  admin: "/admin",
  blog: "/blog",
  //
  // authorization links
  //
  login: "/login/index.html",
  register: "/register/index.html",
  registerSuccess: "/register-success",
  confirmEmail: "/confirm-email/index.html",
  resendConfirmEmail: "/resend-confirm-email",
  closedForAlpha: "/closed-for-alpha",
  resetPassword: "/reset-password/index.html",
  forgotPassword: "/forgot-password",
  //
  // dashboard links
  //
  revise: "/dashboard/revise",
  dashboardHome: "/dashboard/home",
  testResults: "/dashboard/test-results",
  examReview: "/dashboard/exam-review",
  purchase: "/dashboard/purchase",
  exams: "/dashboard/exams",
  examDetail: "/dashboard/exams/:id",
  studyGuide: "/dashboard/study-guide",
  studyGuideModule: "/dashboard/study-guide/:moduleId",
  gsse: "/gsse",
  bps: "/bps",
  gpepau: "/racgp",
  gpepnz: "/gpep-nz"
};

// Helper function to get exam-specific auth links
const getExamAuthLink = (examType: string, authPath: keyof typeof frontEnd) => {
  if (!frontEnd[authPath]) return null;
  return `${examType}${frontEnd[authPath]}`;
};

const backEnd = {
  changePassword: "/api/auth/change-password"
};

const links = {
  frontEnd,
  backEnd,
  getExamAuthLink
};

export default links;
export { frontEnd, backEnd, getExamAuthLink };
